/* eslint-disable */
import React from 'react';
import ReactModal from 'react-modal';
import { RegularButton, AlertAdapter } from 'pg-ui-library';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { useProcessBilling } from '../mutations/expense.mutation';
import { DateTime } from 'luxon';

type ProcessBillingQuery = {
  status: string[];
  employeeName?: string;
  hireType?: string;
  supplierName?: string;
  expenseShowId?: string;
  dateCriteria?: 'period';
  dateFilterType?: string;
  fromDate?: string | null;
  toDate?: string | null;
};

export const ProcessBillingModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  totalExpenses: number;
  filters: any;
}> = ({ isOpen, setIsOpen, totalExpenses, filters }) => {
  console.log('===== ProcessBillingModal Filters =====');
  console.log(filters);
  console.log('===== ProcessBillingModal Filters =====');

  const processBilling = useProcessBilling();

  const handleClose = () => setIsOpen(false);
  const buildBillingQuery = (): ProcessBillingQuery => {
    const { fromDate, toDate } = getApiDateParams();
    console.log('startDate', fromDate);
    console.log('toDate', toDate);

    const query: ProcessBillingQuery = {
      // ALWAYS enforce approved if not selected
      status: filters?.status && filters.status !== '' ? [filters.status] : ['approved'],

      employeeName: filters?.employeeName || undefined,
      hireType: filters?.hireType || undefined,
      supplierName: filters?.supplierName || undefined,
      expenseShowId: filters?.expenseShowId || undefined,

      dateCriteria: 'period',
      dateFilterType: filters?.dateRangeType || undefined,
      fromDate,
      toDate,
    };

    return Object.fromEntries(
      Object.entries(query).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
    ) as ProcessBillingQuery;
  };

  const handleConfirm = async () => {
    try {
      const response = await processBilling.mutateAsync({
        action: 'PROCESS_BILLING',
        query: buildBillingQuery(),
      });

      AlertAdapter('Billing processed successfully!', 'success');

      if (response?.downloadUrl) {
        const link = document.createElement('a');
        link.href = response.downloadUrl;
        link.download = `${response.batchCode}.zip`;
        link.click();
      }

      handleClose();
    } catch {}
  };

  const formatDateForApi = (date: Date | null) => {
    if (!date) return null;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  };

  const getApiDateParams = () => {
    const start = filters.fromDate ? formatDateForApi(filters.fromDate) : null;
    const end = filters.toDate ? formatDateForApi(filters.toDate) : null;

    switch (filters.dateFilterType) {
      case 'after':
        return { fromDate: start, toDate: null };
      case 'before':
        return { fromDate: null, toDate: end };
      case 'between':
        return { fromDate: start, toDate: end };
      case 'exactly':
        return { fromDate: start, toDate: start };
      default:
        return { fromDate: null, toDate: null };
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.6)',
        },
        content: {
          borderRadius: '24px',
          margin: 'auto',
          width: '600px',
          height: '300px',
          padding: '30px',
          background: '#F3F4F8',
        },
      }}
    >
      <div style={{ position: 'relative' }}>
        <CloseIcon
          src={closeSvg}
          onClick={handleClose}
          style={{
            position: 'absolute',
            right: '0',
            top: '0',
            cursor: 'pointer',
          }}
        />

        <h3 style={{ marginBottom: '20px' }}>Process Billing</h3>

        <p style={{ fontSize: '16px', marginBottom: '40px' }}>
          You are about to process billing for <strong>{totalExpenses}</strong> approved expense(s).
          <br />
          Are you sure you want to continue?
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <RegularButton style={{ backgroundColor: '#fff', color: '#4948AC' }} onClick={handleClose}>
            Cancel
          </RegularButton>

          <RegularButton onClick={handleConfirm} disabled={processBilling.isLoading}>
            Confirm
          </RegularButton>
        </div>
      </div>
    </ReactModal>
  );
};
